import axiosInst from '@/utils/axiosinstance';

class LocationService {
  constructor() {
    this.defaultLocation = null;
  }

  async loadDefaultLocation() {
    try {
      const userId = localStorage.getItem('userid');
      if (!userId) return null;

      const { data } = await axiosInst.post('/api/userdetailslist', { userID: userId });
      
      if (data?.items?.[0]) {
        const userDetails = data.items[0];
        this.defaultLocation = {
          address: userDetails.defaultLocation,
          city: userDetails.defaultLocationCity,
          lat: userDetails.defaultLocationLat,
          lng: userDetails.defaultLocationLng
        };
        
        // Store in localStorage for quick access
        if (this.defaultLocation.address) {
          localStorage.setItem('userDefaultLocation', JSON.stringify(this.defaultLocation));
        }
        
        return this.defaultLocation;
      }
      
      return null;
    } catch (error) {
      console.error('Failed to load default location:', error);
      return null;
    }
  }

  getDefaultLocation() {
    // Try memory first
    if (this.defaultLocation) {
      return this.defaultLocation;
    }
    
    // Try localStorage
    const stored = localStorage.getItem('userDefaultLocation');
    if (stored) {
      try {
        this.defaultLocation = JSON.parse(stored);
        return this.defaultLocation;
      } catch {
        localStorage.removeItem('userDefaultLocation');
      }
    }
    
    return null;
  }

  clearDefaultLocation() {
    this.defaultLocation = null;
    localStorage.removeItem('userDefaultLocation');
  }
}

export default new LocationService();
